import script from "./CountryView.vue?vue&type=script&setup=true&lang=js"
export * from "./CountryView.vue?vue&type=script&setup=true&lang=js"

import "./CountryView.vue?vue&type=style&index=0&id=ca1ee9c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca1ee9c2"]])

export default __exports__